export default __webpack_public_path__ + "static/media/pakrap-14.821a7e4c.mp3";